export const namespaced = true;
import axios from 'axios';
import { sortArrayObjectByDate } from '@/utils/shared-functions-vanilla';
import { validateAzvNumber } from '@/utils/shared-functions-vanilla.js';

export const state = {
  doctorOptions: [],
  caseAppointments: [],
  storedVistorSubjects: [],
  currentPatientCaseId: undefined,
  visitorqr: "VISITOR_QR",
  azvNumber: "AZV_NUMBER",
  tubeBarCode: "TUBE_BARCODE"
};

export const mutations = {
  SET_CURRENT_PATIENT_CASE_ID(state, payload) {
    state.currentPatientCaseId = payload;
  },
  SET_DOCTOR_OPTIONS_FOR_VISITORSCANPAGE(state, payload) {
    let doctors = payload.map(doctor => {
      return {
        text: doctor.name,
        value: doctor.id,
        email: doctor.emailAddress
      };
    });
    state.doctorOptions = doctors;
  },

  SET_SUBJECT_CASE_TESTKIT_INFO(state, payload) {
    let testKitData = payload.map(item => {
      item.loading = false;
      return item;
    });
    state.selectedCaseTestKitData = testKitData;
  },

  SET_CASE_APPOINTMENTS(state, payload) {
    state.caseAppointments = payload;
  }
};

export const actions = {
  async createNewTravelerSubjectPaper({ rootState, commit }, payload) {
    return await axios
      .put(`${rootState.baseUrlApiDvg}/healthcheck-restful-api/patientcase/paper/register`, payload)
      .then(res => {
        commit('SET_SHOW_LOADER', { action: false, text: null }, { root: true });
        if (res.status == 200) {
          return res.data;
        } else {
          let payload = {
            open: true,
            text: res.data.errorMessage ? res.data.errorMessage : 'Error loading data from subject',
            color: 'error'
          };
          commit('SET_SNACKBAR', payload, { root: true });
        }
      })
      .catch(error => {
        let payload = {
          open: true,
          text: error?.response?.data?.errorMessage ? error.response.data.errorMessage : 'Error loading data from subject',
          color: 'error'
        };
        commit('SET_SNACKBAR', payload, { root: true });
        console.error(error);
      });
  },

  async createNewLocalSubjectPaper({ rootState, commit }, payload) {
    return await axios
      .put(`${rootState.baseUrlApiDvg}/healthcheck-restful-api/patientcase/paper/register/Local`, payload)
      .then(res => {
        if (res.status == 200) {
          return res.data;
        } else {
          let payload = {
            open: true,
            text: res.data.errorMessage ? res.data.errorMessage : 'Error loading data from subject',
            color: 'error'
          };
          commit('SET_SNACKBAR', payload, { root: true });
        }
      })
      .catch(error => {
        let payload = {
          open: true,
          text: error.response.data.errorMessage ? error.response.data.errorMessage : 'Error loading data from subject',
          color: 'error'
        };
        commit('SET_SNACKBAR', payload, { root: true });
        console.error(error.response.data.errorMessage);
      });
  },

  async getDoctorOptions_forvisitorscanpage({ rootState, commit }) {
    return await axios
      .get(`${rootState.baseUrlApiDvg}/healthcheck-restful-api/hoh/doctorlist`)
      .then(res => {
        if (res.status == 200) {
          commit('SET_DOCTOR_OPTIONS_FOR_VISITORSCANPAGE', res.data);
          return res.data;
        }
      })
      .catch(error => {
        console.log(error);
        let payload = {
          open: true,
          text: 'Error Loading doctor options',
          color: 'error'
        };
        commit('SET_SNACKBAR', payload, { root: true });
      });
  },

  //teskit
  async getPatientTestKitInfo({ rootState, commit, dispatch }, caseId) {
    return await axios
      .get(`${rootState.baseUrlApiDvg}/healthcheck-restful-api/patienttestkit/${caseId}`)
      .then(res => {
        if (res.status == 200) commit('SET_SUBJECT_CASE_TESTKIT_INFO', res.data);
        return res.data;
      })
      .catch(error => {
        console.log(error);
        dispatch('showError', 'Error loading test kit info', { root: true });
      });
  },

  async getTestTubeData({ rootState, commit }, barcode) {
    return await axios
      .get(`${rootState.baseUrlApiDvg}/healthcheck-restful-api/patienttestkit/barcode/${barcode}`)
      //return await axios.get(`http://demo4178399.mockable.io/huisnummer`)
      .then(res => {
        if (res.status == 202) return 'NOT_FOUND';
        else if (res.status == 200) return res.data;
        else {
          let payload = {
            open: true,
            text: res.data.errorMessage ? res.data.errorMessage : 'Error loading data from subject',
            color: 'info'
          };
          commit('SET_SNACKBAR', payload, { root: true });
        }
      })
      .catch(error => {
        let payload = {
          open: true,
          text: error.response.data.errorMessage ? error.response.data.errorMessage : 'Error loading data from subject',
          color: 'error'
        };
        commit('SET_SNACKBAR', payload, { root: true });
      });
  },

  async getVisitorSubjectData({ rootState, commit }, caseId) {
    return await axios
      .get(`${rootState.baseUrlApiDvg}/healthcheck-restful-api/patientcase/qrcode/${caseId}`)
      .then(res => {
        if (res.status == 200) {
          res.data.forEach(item => {
            item.patientTestKit = sortArrayObjectByDate(item.patientTestKit); //TODO sort in db
          });
          return res.data;
        } else {
          let payload = {
            open: true,
            text: res.data.errorMessage ? res.data.errorMessage : 'Error loading data from subject',
            color: 'info'
          };
          commit('SET_SNACKBAR', payload, { root: true });
        }
      })
      .catch(error => {
        console.log(error);
        let payload = {
          open: true,
          text: error.response && error.response.data.errorMessage ? error.response.data.errorMessage : 'Error loading data from subject',
          color: 'error'
        };
        commit('SET_SNACKBAR', payload, { root: true });
      });
  },

  async getSubjectDataAzvNumber({ rootState, dispatch }, payload) {
    return await axios
      .get(`${rootState.baseUrlApiDvg}/healthcheck-restful-api/admin/patientCase/azv/${payload}`)
      .then(res => {
        if (res.status == 200) {
          // res.data = res.data.map(item => {
          //   return { ...item, azvNumber: item.azvCardNumber };
          // });
          return res.data;
        } else {
          dispatch('showError', 'Error loading account from AZV number');
        }
      })
      .catch(error => {
        console.log(error);
        dispatch('showError', 'Error loading account from AZV number', { root: true });
      });
  },

  async linkSubjectToTestTube({ rootState, commit }, payload) {
    commit('SET_SHOW_LOADER', { action: true, text: 'One moment please...' }, { root: true });
    return await axios
      .post(`${rootState.baseUrlApiDvg}/healthcheck-restful-api/patientcase/qrcode/${payload.caseId}`, payload.body)
      .then(res => {
        commit('SET_SHOW_LOADER', { action: false, text: null }, { root: true });
        if (res.status == 200) {
          let payload = {
            open: true,
            text: 'Subject linked to test tube',
            color: 'success'
          };
          commit('SET_SNACKBAR', payload, { root: true });
          return res.data;
        } else {
          let payload = {
            open: true,
            text: res.data.errorMessage ? res.data.errorMessage : 'Subject not linked, something went wrong.',
            color: 'error'
          };
          commit('SET_SNACKBAR', payload, { root: true });
        }
      })
      .catch(error => {
        commit(
          'SET_SHOW_LOADER',
          {
            action: false,
            text: null
          },
          { root: true }
        );
        let payload = {
          open: true,
          text: 'Subject not linked, something went wrong.',
          color: 'error'
        };
        commit('SET_SNACKBAR', payload, { root: true });
        console.error(error);
      });
  },

  //edited modular
  async getCodeType({ commit, dispatch }, payload) {
    let inputStr = payload.input;
    if (inputStr.substring(0, 2) === '^^' && inputStr.substring(inputStr.length - 1) === '^') {
      const trimmedInput = inputStr.substr(2);
      const caseId = trimmedInput.substring(0, trimmedInput.length - 1);
      return { type: 'VISITOR_QR', caseId: caseId };
    } else if (validateAzvNumber(inputStr.trim())) {
      return { type: 'AZV_NUMBER', azvNumber: inputStr.trim() };
    } else if (await dispatch("validateTestTubeString", inputStr)) {
      //only work if subject available to assign tube
      if (payload.primarySubject) {
        return { type: 'TUBE_BARCODE', input: inputStr };
      } else {
        commit('SET_SNACKBAR', { open: true, text: 'Please scan QR code from visitor first', color: 'warning' }, { root: true });
        return { type: null };
      }
    } else {
      let errMsg = "Barcode test tube or AZV number not found or invalid, please try again or scan another one";
      dispatch('showError', errMsg, { root: true });
      return { type: null, setTestTubeMessage: errMsg };
    }
  },

  async scan({ dispatch }, input) {
    if (!input) return;
    if (input?.input == undefined) {
      input = input.trim();
    }
    else input.input = input.input.trim();

    const codeType = await dispatch("getCodeType", { input: input?.input ?? input, primarySubject: input.primarySubject });
    let subjectData = null;
    let testTubeData = null;
    if (codeType.type == 'VISITOR_QR') {
      subjectData = await dispatch('getVisitorSubjectData', codeType.caseId);
      return { displaySubjectData: subjectData, id: codeType.caseId };
      //this.displaySubjectDataInParent(subjectData, codeType.caseId);
    }
    else if (codeType.type == 'AZV_NUMBER') {
      const subjectDataAzv = await dispatch('getSubjectDataAzvNumber', codeType.azvNumber);
      if (subjectDataAzv.length == 0) {
        // this.displayScanError('No results under this AZV number');
        return { error: "No results under this AZV number" };
      } else if (subjectDataAzv.length > 1) {
        // this.displayScanError('Multiple accounts detected with this AZV number. Cannot continue');
        return { error: "Multiple accounts detected with this AZV number. Cannot continue" };
      }
      subjectData = await dispatch('getVisitorSubjectData', subjectDataAzv[0].id);
      // this.displaySubjectDataInParent(subjectData, subjectDataAzv[0].id);
      return { displaySubjectData: subjectData, id: subjectDataAzv[0].id };
    }
    else if (codeType.type == 'TUBE_BARCODE') {
      testTubeData = await dispatch('getTestTubeData', codeType.input);
      if (testTubeData) {
        return { displayTestTubeData: testTubeData, input: codeType.input };
        // this.$emit('displayTestTubeData', testTubeData, codeType.input);
      }
    }
    else if (codeType.setTestTubeMessage) {
      //this.$emit('setTestTubeMessage', codeType.setTestTubeMessage);
      return { testTubeMessage: codeType.setTestTubeMessage };
    }
    // this.scanInputLoading = false;
    // this.scannedInput = null;
  },

  async validateTestTubeString({ dispatch, commit }, input) {
    try {
      let validated = true;
      if (input.length !== 11 && input.length !== 12) validated = false;
      if (!(await dispatch("validateTestPrefix", input))) {
        validated = false;
      }

      const leftOverNumbers = input.substring(this.testTypePrefixLength);
      let leftOverNumbersArray = leftOverNumbers.split('');
      for (let i = 0; i < leftOverNumbersArray.length; i++) {
        const number = leftOverNumbersArray[i];
        if (!/^\d+$/.test(number)) {
          validated = false;
          break;
        }
      }
      //if validated return true
      return validated;
    } catch (error) {
      let payload = {
        open: true,
        text: 'Error validation testtube number',
        color: 'error'
      };
      commit('SET_SNACKBAR', payload, { root: true });
    }
  },

  validateTestPrefix({ rootState }, input) {
    try {
      let validated = false;
      let testTypes = rootState.testTypeStore.testTypePage.testTypes;
      for (let i = 0; i < testTypes.length; i++) {
        const testPrefix = testTypes[i].prefix;
        if (input.startsWith(testPrefix)) {
          this.testTypePrefixLength = testPrefix.length;
          validated = true;
          break;
        }
      }
      return validated;
    } catch (error) {
      this.$store.commit('SET_SNACKBAR', error);
    }
  },

  async searchSubjectPaymentInfo({ rootState, commit }, body) {
    return await axios
      .post(`${rootState.baseUrlApiDvg}/healthcheck-restful-api/testkitpayment?maxSize=5`, body)
      .then(res => {
        if (res.status == 200) return res.data;
      })
      .catch(error => {
        console.log(error);
        let payload = {
          open: true,
          text: 'Error Loading payment data',
          color: 'error'
        };
        commit('SET_SNACKBAR', payload, { root: true });
      });
  },

  async searchTravelers({ rootState, commit }, body) {
    return await axios
      .post(`${rootState.baseUrlApiDvg}/healthcheck-restful-api/passengercard/search`, body)
      .then(res => {
        if (res.status == 200) return res.data;
      })
      .catch(error => {
        console.log(error);
        let payload = {
          open: true,
          text: 'Error Loading Travelers',
          color: 'error'
        };
        commit('SET_SNACKBAR', payload, { root: true });
      });
  },

  async getCaseAppointments({ rootState, commit }, caseId) {
    return await axios
      .get(`${rootState.baseUrlApi}/labhoh-restful-api/reservationcode/patientCaseId/${caseId}`)
      .then(res => {
        if (res.status == 200) {
          commit('SET_CASE_APPOINTMENTS', res.data);
          return res.data;
        }
      })
      .catch(error => {
        console.log(error);
        commit('SET_SNACKBAR', { open: true, text: 'Error loading appointments', color: 'error' }, { root: true });
      });
  },

  async verifyEdCardData({ rootState, dispatch }, payload) {
    return await axios
      .get(`${rootState.baseUrlApiDvg}/healthcheck-restful-api/verify/check/${payload}`)
      .then(res => {
        if (res.status == 200) {
          return res.data;
        } else if (res.status == 202) {
          dispatch('showError', res.data.errorMessage);
        } else {
          dispatch('showError', 'Error getting ED card data', { root: true });
        }
      })
      .catch(error => {
        console.log(error);
        dispatch('showError', 'Error getting ED card data', { root: true });
      });
  }
};

export const getters = {
  caseAppointments: state => {
    return state.caseAppointments;
  },
  visitorQr: state => {
    return state.visitorqr;
  },
  azvNumber: state => {
    return state.azvNumber;
  },
  tubeBarCode: state => {
    return state.tubeBarCode;
  }
};
